import apiCarPass from "@/api/carPass";
import apiPersonalPass from "@/api/personalPass";

const state = {
  autoPasses: [],
  autoPassesAmount: 0,
  autoPassesPaginationLength: 1,

  participantPasses: [],
  participantPassesAmount: 0,
  participantPassesPaginationLength: 1,
  participantPassSorting: [
    {
      value: "date_asc",
      label: "event.passes.sort.by_date_asc",
      i18n: true,
      selected: true,
      sorting: {
        sort_by: "id",
        order_by: "desc"
      }
    },
    {
      value: "date_desc",
      label: "event.passes.sort.by_date_desc",
      i18n: true,
      selected: false,
      sorting: {
        sort_by: "id",
        order_by: "asc"
      }
    },
    {
      value: "name_asc",
      label: "event.passes.sort.by_name_asc",
      i18n: true,
      selected: false,
      sorting: {
        sort_by: "lastname",
        order_by: "asc"
      }
    },
    {
      value: "name_desc",
      label: "event.passes.sort.by_name_desc",
      i18n: true,
      selected: false,
      sorting: {
        sort_by: "lastname",
        order_by: "desc"
      }
    }
  ],

  montagePasses: [],
  montagePassesAmount: 0,
  montagePassesPaginationLength: 1,
  montagePassSorting: [
    {
      value: "date_asc",
      label: "event.passes.sort.by_date_asc",
      i18n: true,
      selected: true,
      sorting: {
        sort_by: "created_at",
        order_by: "desc"
      }
    },
    {
      value: "date_desc",
      label: "event.passes.sort.by_date_desc",
      i18n: true,
      selected: false,
      sorting: {
        sort_by: "created_at",
        order_by: "asc"
      }
    },
    {
      value: "name_asc",
      label: "event.passes.sort.by_name_asc",
      i18n: true,
      selected: false,
      sorting: {
        sort_by: "lastname",
        order_by: "asc"
      }
    },
    {
      value: "name_desc",
      label: "event.passes.sort.by_name_desc",
      i18n: true,
      selected: false,
      sorting: {
        sort_by: "lastname",
        order_by: "desc"
      }
    }
  ],

  staffPasses: [],
  staffPassesAmount: 0,
  staffPassesPaginationLength: 1,
  staffPassSorting: [
    {
      value: "date_asc",
      label: "event.passes.sort.by_date_asc",
      i18n: true,
      selected: true,
      sorting: {
        sort_by: "id",
        order_by: "desc"
      }
    },
    {
      value: "date_desc",
      label: "event.passes.sort.by_date_desc",
      i18n: true,
      selected: false,
      sorting: {
        sort_by: "id",
        order_by: "asc"
      }
    },
    {
      value: "name_asc",
      label: "event.passes.sort.by_name_asc",
      i18n: true,
      selected: false,
      sorting: {
        sort_by: "lastname",
        order_by: "asc"
      }
    },
    {
      value: "name_desc",
      label: "event.passes.sort.by_name_desc",
      i18n: true,
      selected: false,
      sorting: {
        sort_by: "lastname",
        order_by: "desc"
      }
    }
  ]
};

const actions = {
  //AUTO PASS

  async fetchAutoPasses({ commit }, { eventId, page = 1 }) {
    const response = await apiCarPass.getAll(eventId, page);
    if (!response || !response.data) return;
    commit("SET_CAR_PASSES", response.data);
    commit("SET_AUTO_PASSES_PAGINATION_LENGTH", response.meta.last_page);
    commit("SET_AUTO_PASSES_AMOUNT", response.meta.total);
  },

  async addAutoPass({ state, commit, dispatch }, { eventId, pass }) {
    await apiCarPass.add(eventId, pass);
    dispatch("fetchAutoPasses", { eventId });
    commit("SET_AUTO_PASSES_AMOUNT", state.autoPassesAmount + 1);
  },

  async removeAutoPass({ state, commit, dispatch }, { eventId, passId }) {
    await apiCarPass.delete(eventId, passId);
    dispatch("fetchAutoPasses", { eventId });
    commit("SET_AUTO_PASSES_AMOUNT", state.autoPassesAmount - 1);
  },

  async removeAllAutoPasses({ commit, dispatch }, { eventId }) {
    await apiCarPass.deleteAll(eventId);
    dispatch("fetchAutoPasses", { eventId });
    commit("SET_AUTO_PASSES_AMOUNT", 0);
  },

  updateCarPassStatus({ state, commit }, carPass) {
    if (!carPass) return;
    commit(
      "SET_CAR_PASSES",
      state.autoPasses.map(pass => {
        if (pass.id === carPass.id)
          return Object.assign({}, pass, {
            status: carPass.status,
            comment: carPass.comment
          });
        return pass;
      })
    );
  },

  // COMMON PERSONAL PASS
  async fetchParticipantPasses(
    { commit, getters },
    {
      eventId,
      type = "certificate",
      page = 1,
      lastname = getters.personalSelectedSorting.sorting.sort_by,
      order_by = getters.personalSelectedSorting.sorting.order_by
    }
  ) {
    const response = await apiPersonalPass.getAll(
      eventId,
      type,
      page,
      lastname,
      order_by
    );
    if (!response || !response.data) return;
    if (type === "certificate") {
      commit("SET_PERSONAL_PASSES", response.data);
      commit(
        "SET_PARTISIPANT_PASSES_PAGINATION_LENGTH",
        response.meta.last_page
      );
      commit("SET_PERSONAL_PASSES_AMOUNT", response.meta.total);
    } else {
      commit("SET_MONTAGE_PASSES", response.data);
      commit("SET_MONTAGE_PASSES_PAGINATION_LENGTH", response.meta.last_page);
      commit("SET_MONTAGE_PASSES_AMOUNT", response.meta.total);
    }
  },

  //PARTICIPANT PASS
  async addParticipantPass(
    { state, commit, dispatch },
    { eventId, pass, type }
  ) {
    await apiPersonalPass.addParticipantPass(eventId, pass, type);
    dispatch("fetchParticipantPasses", { eventId });
    commit("SET_PERSONAL_PASSES_AMOUNT", state.participantPassesAmount + 1);
  },

  async removeParticipantPass(
    { state, commit, dispatch },
    { eventId, passId }
  ) {
    await apiPersonalPass.delete(eventId, passId);
    dispatch("fetchParticipantPasses", { eventId });
    commit("SET_PERSONAL_PASSES_AMOUNT", state.participantPassesAmount - 1);
  },

  async removeAllParticipantPasses({ commit, dispatch }, { eventId }) {
    await apiPersonalPass.deleteAllParticipantPasses(eventId);
    dispatch("fetchParticipantPasses", { eventId });
    commit("SET_PERSONAL_PASSES_AMOUNT", 0);
  },

  async uploadParticipantPasses({ dispatch }, { eventId, file }) {
    const data = new FormData();
    data.append("type", "certificate");
    data.append("file", file);
    await apiPersonalPass.uploadPasses(eventId, data);
    dispatch("fetchParticipantPasses", { eventId });
  },

  async uploadInstallationPasses({ dispatch }, { eventId, file }) {
    const data = new FormData();
    data.append("type", "installation");
    data.append("file", file);
    await apiPersonalPass.uploadPasses(eventId, data);
    dispatch("fetchParticipantPasses", { eventId, type: "installation" });
  },

  updatePersonalPassStatus({ state, commit }, personalPass) {
    if (!personalPass) return;
    if (personalPass.type === "certificate" || personalPass.type === "visa") {
      commit(
        "SET_PERSONAL_PASSES",
        state.participantPasses.map(pass => {
          if (pass.id === personalPass.id)
            return Object.assign({}, pass, {
              status: personalPass.status
            });
          return pass;
        })
      );
    }
    if (personalPass.type === "installation") {
      commit(
        "SET_MONTAGE_PASSES",
        state.montagePasses.map(pass => {
          if (pass.id === personalPass.id)
            return Object.assign({}, pass, {
              status: personalPass.status
            });
          return pass;
        })
      );
    }
    if (personalPass.type === "staff") {
      commit(
        "SET_STAFF_PASSES",
        state.staffPasses.map(pass => {
          if (pass.id === personalPass.id)
            return Object.assign({}, pass, {
              status: personalPass.status
            });
          return pass;
        })
      );
    }
  },

  // MONTAGE PASS

  async addMontagePass({ state, commit, dispatch }, { eventId, pass }) {
    await apiPersonalPass.addMontagePass(eventId, pass);
    dispatch("fetchParticipantPasses", { eventId, type: "installation" });
    commit("SET_MONTAGE_PASSES_AMOUNT", state.montagePassesAmount + 1);
  },

  async removeInstallationPass(
    { state, commit, dispatch },
    { eventId, passId }
  ) {
    await apiPersonalPass.delete(eventId, passId);
    dispatch("fetchParticipantPasses", { eventId, type: "installation" });
    commit("SET_MONTAGE_PASSES_AMOUNT", state.montagePassesAmount - 1);
  },

  async removeAllInstallationPasses({ commit, dispatch }, { eventId }) {
    await apiPersonalPass.deleteAllInstallationPasses(eventId);
    dispatch("fetchParticipantPasses", { eventId, type: "installation" });
    commit("SET_MONTAGE_PASSES_AMOUNT", 0);
  },

  // STAFF PASS

  async fetchStaffPasses(
    { commit, getters },
    {
      eventId,
      type = "staff",
      page = 1,
      lastname = getters.staffSelectedSorting.sorting.sort_by,
      order_by = getters.staffSelectedSorting.sorting.order_by
    }
  ) {
    const response = await apiPersonalPass.getAll(
      eventId,
      type,
      page,
      lastname,
      order_by
    );
    if (!response || !response.data) return;
    commit("SET_STAFF_PASSES", response.data);
    commit("SET_STAFF_PASSES_PAGINATION_LENGTH", response.meta.last_page);
    commit("SET_STAFF_PASSES_AMOUNT", response.meta.total);
  },

  async addStaffPass({ state, commit, dispatch }, { eventId, pass }) {
    await apiPersonalPass.addStaffPass(eventId, pass);
    dispatch("fetchStaffPasses", { eventId });
    commit("SET_STAFF_PASSES_AMOUNT", state.staffPassesAmount + 1);
  },

  async removeStaffPass({ state, commit, dispatch }, { eventId, passId }) {
    await apiPersonalPass.delete(eventId, passId);
    dispatch("fetchStaffPasses", { eventId });
    commit("SET_STAFF_PASSES_AMOUNT", state.staffPassesAmount - 1);
  },

  async removeAllStaffPasses({ commit, dispatch }, { eventId }) {
    await apiPersonalPass.deleteAllStaffPasses(eventId);
    dispatch("fetchStaffPasses", { eventId });
    commit("SET_STAFF_PASSES_AMOUNT", 0);
  },

  async uploadStaffPasses({ dispatch }, { eventId, file }) {
    const data = new FormData();
    data.append("type", "staff");
    data.append("file", file);
    await apiPersonalPass.uploadPasses(eventId, data);
    dispatch("fetchStaffPasses", { eventId });
  }
};

const mutations = {
  // PARTICIPANT PASS
  SET_PERSONAL_PASSES(state, personalPasses) {
    state.participantPasses = personalPasses;
  },
  SET_PERSONAL_PASSES_AMOUNT(state, amount) {
    state.participantPassesAmount = amount;
  },
  SET_PARTISIPANT_PASSES_PAGINATION_LENGTH(state, page) {
    state.participantPassesPaginationLength = page;
  },
  SET_PERSONAL_PASS_SORTING(state, sorting) {
    state.participantPassSorting = state.participantPassSorting.map(item => {
      item.selected = item.value === sorting.value;
      return item;
    });
  },

  //MONTAGE PASS
  SET_MONTAGE_PASSES(state, montagePasses) {
    state.montagePasses = montagePasses;
  },
  SET_MONTAGE_PASSES_AMOUNT(state, amount) {
    state.montagePassesAmount = amount;
  },
  SET_MONTAGE_PASSES_PAGINATION_LENGTH(state, page) {
    state.montagePassesPaginationLength = page;
  },
  SET_MONTAGE_PASS_SORTING(state, sorting) {
    state.montagePassSorting = state.montagePassSorting.map(item => {
      item.selected = item.value === sorting.value;
      return item;
    });
  },

  //AUTO PASS
  SET_CAR_PASSES(state, carPasses) {
    state.autoPasses = carPasses;
  },
  SET_AUTO_PASSES_AMOUNT(state, amount) {
    state.autoPassesAmount = amount;
  },
  SET_AUTO_PASSES_PAGINATION_LENGTH(state, page) {
    state.autoPassesPaginationLength = page;
  },

  //STAFF PASS
  SET_STAFF_PASSES(state, staffPasses) {
    state.staffPasses = staffPasses;
  },
  SET_STAFF_PASSES_AMOUNT(state, amount) {
    state.staffPassesAmount = amount;
  },
  SET_STAFF_PASSES_PAGINATION_LENGTH(state, page) {
    state.staffPassesPaginationLength = page;
  },
  SET_STAFF_PASS_SORTING(state, sorting) {
    state.staffPassSorting = state.staffPassSorting.map(item => {
      item.selected = item.value === sorting.value;
      return item;
    });
  }
};

const getters = {
  personalSelectedSorting(state) {
    return state.participantPassSorting.find(item => item.selected);
  },
  montageSelectedSorting(state) {
    return state.montagePassSorting.find(item => item.selected);
  },
  staffSelectedSorting(state) {
    return state.staffPassSorting.find(item => item.selected);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
